module.exports = __webpack_public_path__ + "static/media/queue.073f26b9.png";